// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".compare-sidebar {\n  height: 100%;\n  background-color: white;\n}\n", ""]);
// Exports
module.exports = exports;
